import React from 'react';
import { defineBlock, BlockWrapper } from '@smartfire/js-block-engine';
import style from './block.module.scss';
import { Toaster } from 'react-hot-toast';
import { ReactComponent as Logo } from '../assets/MyHand-logo.svg';
import { Socials } from '../components';

function Footer({ socials, secondMenu, menu }) {
    const handleClickConscent = (e) => {
        e.preventDefault();
        /* eslint no-eval: 0 */
        /* eslint no-script-url: 0 */
        eval('javascript:Didomi.preferences.show()');
    };

    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.content}>
                <a href={'/'} className={style.logo}>
                    <Logo />
                </a>

                <div className={style.linksContainer}>
                    {menu &&
                        Object.values(menu).map((elem) => (
                            <a href={elem.url} key={elem.url}>
                                {elem.title}
                            </a>
                        ))}
                </div>

                <div className={style.spacerSocial} />

                <Socials classNames={style.socials} {...socials} />
            </div>

            <div className={style.spacer} />

            <div className={style.subFooter}>
                <div className={style.subLinksContainer}>
                    {secondMenu &&
                        Object.values(secondMenu).map((elem, id) => (
                            <React.Fragment key={elem.url}>
                                <a href={elem.url} className={style.link}>
                                    {elem.title}
                                </a>
                                {'-'}
                            </React.Fragment>
                        ))}

                    <button className={style.link} onClick={handleClickConscent}>
                        Gestion des consentements
                    </button>
                </div>
            </div>
            <Toaster
                toastOptions={{
                    className: style.toaster,
                }}
            />
        </BlockWrapper.Div>
    );
}

export default defineBlock({
    Block: Footer,
    setup: {
        title: 'Footer',
    },
});
